export function hex2rgb(hex) {
  let result = /^#?([a-f\d]{1,2})([a-f\d]{1,2})([a-f\d]{1,2})([a-f\d]{1,2})?$/i.exec(
    hex
  );
  if (!result) return;
  let [r, g, b, a] = result
    .slice(1, 5)
    .map(r => (r && r.length == 1 ? r + r : r))
    .map(r => r && parseInt(r, 16));
  return { r, g, b, a };
}

function rgb2hsl({ r, g, b, a }) {
  r /= 255;
  g /= 255;
  b /= 255;

  let cmin = Math.min(r, g, b),
    cmax = Math.max(r, g, b),
    delta = cmax - cmin,
    h = 0,
    s = 0,
    l = 0;

  if (delta == 0) h = 0;
  else if (cmax == r) h = ((g - b) / delta) % 6;
  else if (cmax == g) h = (b - r) / delta + 2;
  else h = (r - g) / delta + 4;

  h = Math.round(h * 60);
  if (h < 0) h += 360;

  l = (cmax + cmin) / 2;
  s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));

  l = +(l * 100).toFixed(1);
  s = +(s * 100).toFixed(1);

  return { h, s, l, a };
}

export function getContrastBW(hex) {
  const rgb = hex2rgb(hex);
  const hsl = rgb2hsl(rgb);
  const normalization = hsl.l - 60 + (Math.abs(hsl.h - 230) - hsl.s) / 30;
  return normalization > 0 ? "black" : "white";
}

export function prependHash(hex) {
  return hex.indexOf("#") != 0 ? `#${hex}` : hex;
}
